export const precision_to_step = (precision: number) => (10 ** -precision)

export const step_to_precision = (step: number) => -Math.log10(step)
